document.addEventListener("DOMContentLoaded", () => {
  // Sprawdź, czy na stronie znajduje się element z klasą wskazującą na karuzelę
  const carousel = document.querySelector(".x-swiper-controls__inner");
  if (!carousel) return; // Jeśli brak karuzeli, zakończ działanie skryptu

  const observer = new MutationObserver(initCustomNav);
  observer.observe(document.body, { childList: true, subtree: true });

  const SVG_LEFT_SMALL = `<svg width="15" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2711 24L13.2463 23.047L2.64106 12.6746L30 12.6746L30 11.3254L2.63925 11.3254L13.2463 0.954825L12.2711 3.57435e-07L-8.58247e-07 11.9997L12.2711 24Z" fill="#000000" fill-opacity="0.3"/></svg>`;
  const SVG_LEFT_BIG = `<svg width="45" height="24" viewBox="0 0 93 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1616 24L13.1281 23.047L2.6175 12.6746L93 12.6746V11.3254L2.6157 11.3254L13.1281 0.9548L12.1616 0L0 11.9997L12.1616 24Z" fill="#000000"/></svg>`;
  const SVG_RIGHT_SMALL = `<svg width="15" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7289 0L16.7537 0.953045L27.3589 11.3254L1.12738e-06 11.3254L1.12738e-06 12.6746L27.3607 12.6746L16.7537 23.0452L17.7289 24L30 12.0003L17.7289 0Z" fill="#000000" fill-opacity="0.3"/></svg>`;
  const SVG_RIGHT_BIG = `<svg width="45" height="24" viewBox="0 0 93 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M80.8384 0L79.8719 0.953045L90.3825 11.3254H0V12.6746H90.3843L79.8719 23.0452L80.8384 24L93 12.0003L80.8384 0Z" fill="#000000"/></svg>`;

  initCustomNav();

  function initCustomNav() {
    document
      .querySelectorAll(
        ".x-swiper-controls__inner:not([data-custom-nav-injected])"
      )
      .forEach((controlsInner) => {
        const pag = controlsInner.querySelector(
          ".x-swiper-pagination-clickable.swiper-pagination-bullets"
        );
        if (!pag) return;

        const bullets = pag.querySelectorAll(
          ".x-swiper-pagination-bullet"
        );
        const total = bullets.length;
        if (total === 0) return;

        // Hide default dots
        pag.style.display = "none";

        // Create and inject custom nav
        const nav = document.createElement("div");
        nav.className = "my-swiper-nav";
        nav.innerHTML = `
          <button class="my-prev" aria-label="Poprzedni">${SVG_LEFT_BIG}</button>
          <span class="my-counter">1</span>
          <button class="my-next" aria-label="Następny">${SVG_RIGHT_BIG}</button>
         
         
        `;
        pag.insertAdjacentElement("afterend", nav);

        const counter = nav.querySelector(".my-counter");
        const prevBtn = nav.querySelector(".my-prev");
        const nextBtn = nav.querySelector(".my-next");

        let current = 1;
        counter.textContent = current;

        const updateFromActiveBullet = () => {
          const activeIndex = Array.from(bullets).findIndex((b) =>
            b.classList.contains("x-swiper-pagination-bullet-active")
          );
          if (activeIndex !== -1) {
            current = activeIndex + 1;
            counter.textContent = current;
            updateArrowSizes();
          }
        };

        const updateArrowSizes = () => {
          prevBtn.innerHTML = current === 1 ? SVG_LEFT_SMALL : SVG_LEFT_BIG;
          nextBtn.innerHTML = current === total ? SVG_RIGHT_SMALL : SVG_RIGHT_BIG;
        };

        const bulletObserver = new MutationObserver(updateFromActiveBullet);
        bulletObserver.observe(pag, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class"],
        });

        prevBtn.addEventListener("click", () => {
          const prev = controlsInner.querySelector(".x-swiper-button-prev");
          if (current > 1 && prev) {
            prev.click();
          }
        });

        nextBtn.addEventListener("click", () => {
          const next = controlsInner.querySelector(".x-swiper-button-next");
          if (current < total && next) {
            next.click();
          }
        });

        controlsInner.setAttribute("data-custom-nav-injected", "true");

        updateArrowSizes();
      });
  }
});


  // Obsługa wielu przycisków z klasą open-popup
  document.querySelectorAll('#open-popup').forEach(function (button) {
    button.addEventListener('click', function () {
      document.getElementById('iframe-popup').style.display = 'flex';
    });
  });

  // Zamknięcie popupu
  document.querySelectorAll('.close-popup').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.getElementById('iframe-popup').style.display = 'none';
    });
  });

  // Zamykanie klikając poza popup-content
  document.getElementById('iframe-popup').addEventListener('click', function (e) {
    const content = document.querySelector('.popup-content');
    if (!content.contains(e.target)) {
      document.getElementById('iframe-popup').style.display = 'none';
    }
  });


// SVG constants
const SVG_LEFT_SMALL = `<svg width="15" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2711 24L13.2463 23.047L2.64106 12.6746L30 12.6746L30 11.3254L2.63925 11.3254L13.2463 0.954825L12.2711 3.57435e-07L-8.58247e-07 11.9997L12.2711 24Z" fill="#000000" fill-opacity="0.3"/></svg>`;
const SVG_LEFT_BIG = `<svg width="45" height="24" viewBox="0 0 93 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1616 24L13.1281 23.047L2.6175 12.6746L93 12.6746V11.3254L2.6157 11.3254L13.1281 0.9548L12.1616 0L0 11.9997L12.1616 24Z" fill="#000000"/></svg>`;
const SVG_RIGHT_SMALL = `<svg width="15" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7289 0L16.7537 0.953045L27.3589 11.3254L1.12738e-06 11.3254L1.12738e-06 12.6746L27.3607 12.6746L16.7537 23.0452L17.7289 24L30 12.0003L17.7289 0Z" fill="#000000" fill-opacity="0.3"/></svg>`;
const SVG_RIGHT_BIG = `<svg width="45" height="24" viewBox="0 0 93 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M80.8384 0L79.8719 0.953045L90.3825 11.3254H0V12.6746H90.3843L79.8719 23.0452L80.8384 24L93 12.0003L80.8384 0Z" fill="#000000"/></svg>`;

function replaceSwiperArrows() {
  const swiperControls = document.querySelector('.x-swiper-controls');
  if (!swiperControls) return; // carousel not found

  const prevBtn = swiperControls.querySelector('.x-swiper-button-prev');
  const nextBtn = swiperControls.querySelector('.x-swiper-button-next');

  if (prevBtn) {
    prevBtn.innerHTML = prevBtn.classList.contains('x-swiper-button-disabled')
      ? SVG_LEFT_SMALL
      : SVG_LEFT_BIG;
  }

  if (nextBtn) {
    nextBtn.innerHTML = nextBtn.classList.contains('x-swiper-button-disabled')
      ? SVG_RIGHT_SMALL
      : SVG_RIGHT_BIG;
  }
}

// DOM ready check
if (document.readyState !== 'loading') {
  replaceSwiperArrows();
} else {
  document.addEventListener('DOMContentLoaded', replaceSwiperArrows);
}

